import { User } from 'oidc-client-ts';
import { AuthProvider } from 'react-oidc-context';

import { AppRouter } from './router';
import instanceConfig from './instance';
import { InstanceProvider } from './contexts/';
import { VersionPanel } from './components/version-panel';
import { VersionInfoProvider } from './contexts/version-info';

declare global {
  interface Window {
    _env_: any;
  }
}

// prettier-ignore
const oidcConfig = {
  onSignIn: () => {
    // Redirect?
  },
  onSigninCallback: (_user: User | void): void => {
    window.history.replaceState( {}, document.title, window.location.pathname);
  },
  authority: window?._env_?.REACT_APP_AUTHORITY || process.env.REACT_APP_AUTHORITY,
  client_id: window?._env_?.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID,
  redirect_uri: window?._env_?.REACT_APP_REDIRECT_URI || process.env.REACT_APP_REDIRECT_URI,
  scope: 'offline_access openid profile', // offline_access scope allow your client to retrieve the refresh_token
  silent_redirect_uri: window?._env_?.REACT_APP_SILENT_REDIRECT_URI || process.env.REACT_APP_SILENT_REDIRECT_URI,
  loadUserInfo: true,
  post_logout_redirect_uri: window?._env_?.REACT_APP_REDIRECT_URI || process.env.REACT_APP_REDIRECT_URI
};

// prettier-ignore
function App() {
  return (
    <InstanceProvider {...instanceConfig}>
      <VersionInfoProvider>
        <AuthProvider {...oidcConfig}>
          <AppRouter />
          <VersionPanel />
        </AuthProvider>
      </VersionInfoProvider>
    </InstanceProvider>
  );
}

export default App;
